export const periodTypes = {
    immediately: 'immediately',
    dayOfMonth: 'day-of-month',
    dayOfWeek: 'day-of-week',
};

export default periodTypes;
